import {ICheckinCheckoutDate} from './hotels-types';

export interface UserCityPaxItem {
  cityId: string;
  checkin: ICheckinCheckoutDate;
  checkout: ICheckinCheckoutDate;
  pax: string;
  uuid: string;
}

export interface IStepRange {
  min: number;
  max: number;
}

export interface ILocation_Search {
  id_type: string;
  loc_id: string;
  n: string;
}

export interface IQuickFilterItem {
  fid?: string;
  n?: string;
  c?: number;
}

export interface IFilters {
  range_ugc?: Array<number>;
  tags?: Array<string>;
  tag?: string;
  lid?: Array<string>;
  utag?: Array<IQuickFilterItem>;
  qf?: Array<IQuickFilter>;
  step_range?: Array<IStepRange>;
  star?: Array<number>;
  type?: Array<string>;
  chain?: Array<string>;
  amenities?: Array<string>;
  location_search?: Array<ILocation_Search>;
  fbfi?: number;
  pah?: number;
  isrnpl?: number;
  gt?: number;
  fcp?: number;
  ht?: string;
  dis?: Array<string>;
  food_dining?: Array<string>;
  sale_campaign?: string;
}

export interface IQuickFilter {
  n: string;
  fd: IFilters;
  o?: Array<IQuickFilterItem>;
  m?: number;
}

export interface PopularFiltersShape {
  popular: Popular;
  transit: Popular;
}

export interface Popular {
  n: string;
  sh: string;
  fc: number;
  fd: Fd;
}

export interface Fd {
  fk: string;
  fkt: string;
  o: FilterItem[];
  ms: boolean;
}

export interface FilterItem {
  n: string;
  v: V;
  type: Type;
  nh: number;
}

export interface V {
  loc_id: string;
  id_type: IDType;
  n: string;
}

export enum IDType {
  MmtArea = 'mmt_area',
  MmtPoi = 'mmt_poi',
}

export interface MatchMakerDataMap {
  id: string;
  name: string;
  type: Type;
  centre: Centre;
}

export interface Centre {
  lat: string;
  lng: string;
}

export enum Type {
  Area = 'area',
  Poi = 'poi',
  Transit = 'Transit',
}

//Filter Types

export enum FilterSuffix {
  DEFAULT = 'hotels_home',
  BOTTOM_BAR = 'bottom_bar',
  TOP_BAR = 'top_bar',
}
export interface ApplyFilterProps {
  newSortApplied?: string;
}

export interface Filter {
  filterGroup: string;
  filterValue: string;
  title: string;
  rangeFilter?: boolean;
  filterRange?: {
    minValue: number;
    maxValue: number;
  };
  quantityFilter?: boolean;
  count?: number;
  preApplied?: boolean;
  filterExists?: boolean;
  imageUrl?: string;
}
export interface FilterObject {
  title: string;
  min?: number;
  max?: number;
  value?: string;
  id_type?: string;
  loc_id?: string;
  n?: string;
  suffix: FilterSuffix;
}
export interface Location {
  n: string;
  nh?: number;
  v: {
    id_type: string;
    loc_id: string;
    n: string;
  };
}

export interface OnAppliedFilterUpdateParams {
  appliedFiltersFromProps?: FilterObject[];
  appliedLocationsFromProps?: FilterObject[];
}

export interface FilterSection {
  filters: (Filter & Location)[];
  title: string;
  viewType: string;
  showMore?: boolean;
  visible?: boolean;
  showCustomRange?: boolean;
  categoryName?: string;
  searchable?: boolean;
  showImageUrl?: boolean;
  minItemsToShow?: number;
  singleSelection?: boolean;
}

export interface ResponseData {
  filteredCount: number;
  totalCount: number;
  minPrice: number;
  limited: boolean;
  filterList: FilterSection[];
}

export interface HandleFilterClickParams {
  filterGroup: string;
  filterObj: FilterObject;
  isMultiple?: boolean;
  filterAction: FilterActionTypes;
  filterType?: FilterClickTypes;
  isFilterCall?: boolean;
  callBack?: (params: any) => void;
}

export interface Region {
  ind: string;
  name: string;
  id: string;
  voyId: string;
  type: string;
}

export interface TempLocationModalProps {
  tempAppliedLocations: Record<string, FilterObject[]>;
  handleTempClick: (params: HandleFilterClickParams) => void;
  onApplyTempFilters: () => void;
  tempLocationReset: () => void;
}

export enum FilterClickTypes {
  Temp = 'temp',
  Filter = 'filter',
  Location = 'location',
}

export enum FilterActionTypes {
  Apply = 'APPLY',
  ApplyGroup = 'APPLY_GROUP',
  Remove = 'REMOVE',
  Reset = 'RESET',
  Default = 'DEFAULT',
  Init = 'INIT',
}
